module.exports = __webpack_public_path__ + "img/zwsj.b26f8951.png";